export const cigaretteStyle: Record<string, any> = {
  regular: {
    width: '28px',
    height: '298px',
  },

  compact: {
    width: '21px',
    height: '298px',
  },

  'compact-super-thin': {
    width: '18px',
    height: '298px',
  },

  'regular-extended': {
    width: '28px',
    height: '357px',
  },

  'compact-extended': {
    width: '21px',
    height: '357px',
  },

  'super-thin': {
    width: '18px',
    height: '357px',
  },
};

export const formats: Record<number, string> = {
  // TODO:: уточнить, может ли меняться порядок форматов в админке
  0: 'regular',
  1: 'regular-extended',
  2: 'super-thin',
  3: 'compact-super-thin',
  4: 'compact-extended',
  5: 'compact',
};
